var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-picker',_vm._g(_vm._b({model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'date-picker',_vm.$attrs,false),_vm.$attrs.on))
}
var staticRenderFns = []

export { render, staticRenderFns }